import { createSlice } from '@reduxjs/toolkit'

interface SessionState {
  startedAt: string
}

const initialState: SessionState = {
  startedAt: new Date().toISOString(),
}

export const SessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {},
})

export default SessionSlice.reducer
